import styled from "styled-components/macro";
import { DataDumpAggregateType } from "types/types";
import { useFlightTranslation } from "utils/customHooks/useFlightTranslation";
import {
  useAheadBehindMetrics,
  handleABSpecialMetrics,
} from "./aheadBehindUtils";

export function OperatorPageMetrics({
  dataDumpCurrentHour,
  hourCurrentTarget: hourTarget,
  hourCount,
  hourTotalTarget: hourAheadBehind,
  dataDumpCurrentShift,
  shiftCurrentTarget: shiftTarget,
  shiftCount,
  shiftTotalTarget: shiftAheadBehind,
  horizontalLayout = false,
  hourOrShift,
}: {
  dataDumpCurrentHour: DataDumpAggregateType | null;
  hourCurrentTarget: number | null;
  hourCount: number | null;
  hourTotalTarget: number | null;
  dataDumpCurrentShift: DataDumpAggregateType | null;
  shiftCurrentTarget: number | null;
  shiftCount: number | null;
  shiftTotalTarget: number | null;
  horizontalLayout?: boolean;
  hourOrShift: "hour" | "shift" | "both";
}) {
  const {
    operatorPageOnlyMetrics_Shift,
    operatorPageOnlyMetrics_Hour,
    metricsLoading,
  } = useAheadBehindMetrics(dataDumpCurrentHour);
  const { translate } = useFlightTranslation();
  return (
    <OperatorPageMetricsStyles
      className={`operatorPageMetrics hourOrShift-${hourOrShift}`}
    >
      {operatorPageOnlyMetrics_Shift.length
        ? operatorPageOnlyMetrics_Shift.map((metric, idx) => {
            const valueDisplayHour = handleABSpecialMetrics({
              metric,
              target: hourTarget,
              count: hourCount,
              aheadBehind: hourAheadBehind,
              dataDump: dataDumpCurrentHour,
            });
            const valueDisplayShift = handleABSpecialMetrics({
              metric,
              target: shiftTarget,
              count: shiftCount,
              aheadBehind: shiftAheadBehind,
              dataDump: dataDumpCurrentShift,
            });
            let displayName = translate(
              metric.displayNameShort ?? metric.displayName
            );
            if (metric.dataDumpKey === "outputLossSum") {
              displayName = translate("Total Target Output");
            } else if (metric.dataDumpKey === "netOutput") {
              displayName = translate("Current Output");
            }
            const valueHour =
              valueDisplayHour?.toFixed(
                operatorPageOnlyMetrics_Hour[idx]?.decimalPoints ?? 0
              ) ?? "--";
            const valueShift =
              valueDisplayShift?.toFixed(
                operatorPageOnlyMetrics_Shift[idx]?.decimalPoints ?? 0
              ) ?? "--";

            const displayShiftValueOnly = hourOrShift === "shift";

            return (
              <div
                className={`metric-${metric.dataDumpKey} info targetCountInfo operatorMetricInfo`}
                key={metric.dataDumpKey}
              >
                {horizontalLayout ? (
                  <>
                    <div className="count operatorMetricValue">
                      {metricsLoading ? "--" : valueHour}
                    </div>
                    <div className="countLabel middle value">
                      {displayName} {metric.units ? `(${metric.units})` : ""}
                    </div>
                    <div className="count operatorMetricValue">
                      {metricsLoading ? "--" : valueShift}
                    </div>
                  </>
                ) : (
                  <>
                    <div className="countLabel middle value">
                      {displayName} {metric.units ? `(${metric.units})` : ""}
                    </div>
                    <div className="count operatorMetricValue">
                      {metricsLoading
                        ? "--"
                        : displayShiftValueOnly
                          ? valueShift
                          : valueHour}
                    </div>
                  </>
                )}
              </div>
            );
          })
        : null}
    </OperatorPageMetricsStyles>
  );
}
const OperatorPageMetricsStyles = styled.div`
  &&& {
    .metric-netOutput {
      color: #000000;
    }
  }
`;
